<script setup lang="ts">
const BUBBLES = [
  { own: false, width: 42, height: 40 },
  { own: false, width: 28, height: 40 },
  { own: true, width: 55, height: 56 },
  { own: false, width: 64, height: 72 },
  { own: true, width: 34, height: 40 },
  { own: true, width: 48, height: 40 },
  { own: false, width: 38, height: 56 },
  { own: true, width: 60, height: 72 },
  { own: false, width: 24, height: 40 },
  { own: false, width: 52, height: 56 },
  { own: true, width: 30, height: 40 },
  { own: false, width: 46, height: 40 },
  { own: true, width: 66, height: 56 },
  { own: false, width: 36, height: 40 },
];
</script>
<template>
  <div class="messages-skeleton d-flex flex-column justify-end h-100 overflow-hidden" data-qa="messages-skeleton">
    <div
      v-for="(bubble, index) in BUBBLES"
      :key="index"
      :class="{ 'messages-skeleton__bubble--own': bubble.own }"
      :style="{ width: `${bubble.width}%`, height: `${bubble.height}px` }"
      class="messages-skeleton__bubble flex-shrink-0 mb-2"
    />
  </div>
</template>
<style lang="scss" scoped>
.messages-skeleton {
  padding-top: 20px;

  &__bubble {
    position: relative;
    overflow: hidden;
    border-radius: 8px 8px 8px 0;
    background: rgba(var(--v-theme-on-surface), 0.08);

    &--own {
      margin-left: auto;
      border-radius: 8px 8px 0 8px;
    }

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        rgba(var(--v-theme-surface), 0),
        rgba(var(--v-theme-surface), 0.6),
        rgba(var(--v-theme-surface), 0)
      );
      animation: messages-skeleton-shimmer 1.5s infinite;
    }
  }
}

@keyframes messages-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
